import { Fragment, useEffect, useId, useState } from 'react';
import { Tooltip } from '../Tooltip';
import { TextContainer, Subtitle, Title } from './styled';
export function AvatarLabel(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { title, subtitle, truncate, labelTooltip } = props;
    const id = useId();
    const [elements, setElements] = useState({});
    useEffect(() => {
        const titleElement = document.getElementById(`${id}-title`);
        const subtitleElement = document.getElementById(`${id}-subtitle`);
        setElements({
            title: titleElement,
            subtitle: subtitleElement,
        });
    }, [title, subtitle, id]);
    const displayTooltip = ((_b = (_a = elements.title) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0) < ((_d = (_c = elements.title) === null || _c === void 0 ? void 0 : _c.scrollWidth) !== null && _d !== void 0 ? _d : 0) ||
        ((_f = (_e = elements.subtitle) === null || _e === void 0 ? void 0 : _e.offsetWidth) !== null && _f !== void 0 ? _f : 0) < ((_h = (_g = elements.subtitle) === null || _g === void 0 ? void 0 : _g.scrollWidth) !== null && _h !== void 0 ? _h : 0);
    const tooltipTitle = (<Fragment>
      {title} {subtitle}
    </Fragment>);
    if (!title && !subtitle) {
        return null;
    }
    return (<Tooltip disabled={!displayTooltip} title={tooltipTitle} {...labelTooltip}>
      <TextContainer tabIndex={displayTooltip ? 0 : undefined}>
        {title && (<Title id={`${id}-title`} $truncate={truncate}>
            {title}
          </Title>)}
        {subtitle && (<Subtitle id={`${id}-subtitle`} $truncate={truncate}>
            {subtitle}
          </Subtitle>)}
      </TextContainer>
    </Tooltip>);
}
